import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled, { css } from 'styled-components';

import { colorsV2 } from '../../../../../colors-v2';
import { BaseCardLogicProps } from '../../CardLogicPlugin.types';
import { CardLogicActionMenu } from '../../components/CardLogicActionMenu';
import { useCardLogicStore } from '../../model/card-logic.store';
import { CARD_LOGIC_CELL_CLASS_NAME, ELEMENT_BY_ID_ATTRIBUTES } from '../../model/constants';

interface CardLogicCellElementProps extends BaseCardLogicProps {}

export const CardLogicCellSharedStyle = css`
  position: relative;

  .cell-wrapper {
    display: grid;
    position: relative;

    .card-logic-action-menu {
      position: absolute;
      top: 10px;
      right: 10px;
      display: none;
    }

    &:hover {
      .card-logic-action-menu {
        display: block;
      }
    }
  }

  .text {
    font-size: 18px;
    line-height: 28px;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

/* stylelint-disable */
const Main = styled.div<{ textAlign }>`
  ${CardLogicCellSharedStyle}
  background: ${colorsV2.white100};

  .cell-wrapper {
    align-items: flex-start;
    border: 0.5px solid ${colorsV2.gray60};
    border-radius: 8px;
    padding: 8px;
  }

  .text {
    text-align: ${(p) => p.textAlign};
  }

  &.read-only {
    &.selected {
      .cell-wrapper {
        border: 1px solid ${colorsV2.blue100};
      }
    }
    .cell-wrapper {
      :focus-within {
        border: 1px solid ${colorsV2.blue100};
      }
    }
  }

  &.delete-hovered {
    .cell-wrapper {
      background-color: ${colorsV2.red10};
      border-color: ${colorsV2.red100};
      border-width: 1px;
    }
  }
`;

export const CardLogicCellElementEditable = observer((props: CardLogicCellElementProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const { textAlign } = element;
  const cardLogicStore = useCardLogicStore();

  return (
    <Main
      {...attributes}
      {...{ [ELEMENT_BY_ID_ATTRIBUTES]: element.id }}
      textAlign={textAlign}
      className={cl(CARD_LOGIC_CELL_CLASS_NAME, {
        'read-only': isReadOnly,
        selected: cardLogicStore?.currentSelection?.cellNodeElementId === element.id,
        'delete-hovered': cardLogicStore.deleteButtonHovering,
      })}
    >
      <div className="cell-wrapper">
        <div className="text">{children}</div>
        <CardLogicActionMenu element={element} variant="CELL" />
      </div>
    </Main>
  );
});

export const CardLogicCellElementReadOnly = (props: CardLogicCellElementProps) => {
  const { attributes, children, element } = props;
  const { textAlign } = element;

  return (
    <Main
      {...attributes}
      textAlign={textAlign}
      className={cl(CARD_LOGIC_CELL_CLASS_NAME, 'read-only')}
    >
      <div className="cell-wrapper text" tabIndex={1}>
        {children}
      </div>
    </Main>
  );
};
